import api from './api';

// Retrieve all white papers
export const getWhitePapers = async () => {
  try {
    const response = await api.get('/whitepapers');
    return response.data;
  } catch (error) {
    console.error('Error fetching white papers:', error);
    throw error;
  }
};

// Retrieve a white paper by its ID
export const getWhitePaperById = async (id) => {
  try {
    const response = await api.get(`/whitepapers/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching white paper with id ${id}:`, error);
    throw error;
  }
};

// Retrieve a white paper by its slug
export const getWhitePaperBySlug = async (slug) => {
  try {
    const response = await api.get(`/whitepapers/slug/${slug}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching white paper with slug ${slug}:`, error);
    throw error;
  }
};

// Create a new white paper
export const createWhitePaper = async (whitePaperData) => {
  try {
    const response = await api.post('/whitepapers', whitePaperData);
    return response.data;
  } catch (error) {
    console.error('Error creating white paper:', error);
    throw error;
  }
};

// Update an existing white paper
export const updateWhitePaper = async (id, whitePaperData) => {
  try {
    const response = await api.put(`/whitepapers/${id}`, whitePaperData);
    return response.data;
  } catch (error) {
    console.error(`Error updating white paper with id ${id}:`, error);
    throw error;
  }
};

// Delete a white paper
export const deleteWhitePaper = async (id) => {
  try {
    const response = await api.delete(`/whitepapers/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting white paper with id ${id}:`, error);
    throw error;
  }
};
